<template>
	<i :class="[isFullscreen?'icon-tuichuquanping':'icon-quanping','ali-iconfont']" @click="click"></i>
</template>

<script>
	import screenfull from 'screenfull'

	export default {
		name: 'Screenfull',
		data() {
			return {
				isFullscreen: false
			}
		},
		methods: {
			click() {
				this.isFullscreen = !this.isFullscreen;
				screenfull.toggle()
			}
		}
	}
</script>
